import { render, staticRenderFns } from "./QuestionMu.vue?vue&type=template&id=c33acd20&scoped=true&"
import script from "./QuestionMu.vue?vue&type=script&lang=js&"
export * from "./QuestionMu.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMu.vue?vue&type=style&index=0&id=c33acd20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33acd20",
  null
  
)

export default component.exports